/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetPrivilegesResponse } from '../models/get-privileges-response';

@Injectable({ providedIn: 'root' })
export class PrivilegesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllPrivileges()` */
  static readonly GetAllPrivilegesPath = '/api/v1/privileges';

  /**
   * Get list of privileges.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPrivileges()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPrivileges$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields. - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetPrivilegesResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PrivilegesService.GetAllPrivilegesPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetPrivilegesResponse>;
        })
      );
  }

  /**
   * Get list of privileges.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPrivileges$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPrivileges(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields. - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetPrivilegesResponse> {
    return this.getAllPrivileges$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetPrivilegesResponse>): GetPrivilegesResponse =>
          r.body
      )
    );
  }
}
